export default __webpack_public_path__ + "static/IMG_5717_Tomasz_small-25562f66e7cbcce0287b786e238c86d1.jpg";